<template>
  <div class="player" :class="isRotateFullScreen ? 'isFullPlayer' : ''">
    <video
      class="video-player"
      :id="`player${playerVideo.id}`"
      preload="none"
      :poster="poster"
      playsinline
      webkit-playsinline
    >
    </video>
    <div class="vertical-progress" :class="isRotateFullScreen ? 'isFull' : ''">
      <van-slider v-model="slider" vertical button-size="14" @change="handleChange"/>
    </div>
    <div
      class="video-block"
      v-if="!isPlayVideo"
      :style="poster ? { backgroundImage: `url(${poster})` } : {}"
    >
      <img src="@/assets/images/course/icon-play-course.png" class="icon-video" alt="" @click.stop="playTheVideo"/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {handleTraceVideo, handleTraceVideoAsync} from '@/utils/trace.js'
import {stopScroll, canScroll} from '@/utils/util'
import {iconForward, iconBack} from '@/views/course/components/svg.js'
import {ACCESS_TOKEN} from '@/store/mutation-types'
export default {
  name: 'VideoPlayer',
  props: {
    // 视频源
    playerVideo: {
      type: Object,
      required: true
    },
    // 是否启用埋点
    enableTrace: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 是否已经rotate全屏
      isRotateFullScreen: false,
      playDurationArr: [],
      playDuration: 0,
      playDurationTrace: 0,
      curVideoPlayer: {},
      precurVideoPlayer: null,
      curVideoDuration: 0,
      player: null,
      poster: '',
      isPlayVideo: false,
      slider: 0,
      currentTime: 0,
      acPlayerToolInit: null,
      videoDom: null,
      onWebkitBeginFullscreen: null,
      onWebkitEndFullscreen: null,
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  watch: {
    playerVideo(newVal, oldVal) {
      if (!newVal) {
        this.destroyPlayer()
        return
      }
      // 避免同一个视频在父组件重新渲染（比如切换 tab）时被误判为变更导致销毁重建
      const isSameVideo = oldVal &&
        newVal.id === oldVal.id &&
        newVal.fileId === oldVal.fileId &&
        newVal.psign === oldVal.psign

      this.curVideoPlayer = newVal
      this.poster = newVal.poster ? newVal.poster : newVal.coverUrl || this.curVideoPlayer.url
      if (isSameVideo) return

      this.isPlayVideo = false
      this.currentTime = 0
      this.playDurationArr = []
      this.playDurationTrace = 0
      this.playDuration = 0
      this.slider = 0
      this.precurVideoPlayer = null
      this.destroyPlayer()
    }
  },
  mounted() {
    this.curVideoPlayer = this.playerVideo
    this.poster = this.curVideoPlayer.poster ? this.curVideoPlayer.poster : this.curVideoPlayer.coverUrl || this.curVideoPlayer.url
    window.addEventListener('unload', this.unloadHandler)
  },
  beforeDestroy() {
    if (this.player && this.enableTrace) this.handleVideoTrace(this.curVideoPlayer)
    if (this.videoDom && this.onWebkitBeginFullscreen) {
      this.videoDom.removeEventListener('webkitbeginfullscreen', this.onWebkitBeginFullscreen)
    }
    if (this.videoDom && this.onWebkitEndFullscreen) {
      this.videoDom.removeEventListener('webkitendfullscreen', this.onWebkitEndFullscreen)
    }
    this.onWebkitBeginFullscreen = null
    this.onWebkitEndFullscreen = null
    this.videoDom = null
    this.destroyPlayer()
    localStorage.removeItem('playbackRate')
    localStorage.removeItem('curPlayVideoId')
    canScroll()
  },
  destroyed() {
    window.removeEventListener('unload', this.unloadHandler)
  },
  methods: {
    destroyPlayer() {
      if (this.acPlayerToolInit && this.player) {
        if (this.acPlayerToolInit.dispose && this.acPlayerToolInit.isPlayed) {
          this.acPlayerToolInit.dispose()
        } else if (this.player.dispose) {
          this.player.dispose()
        }
      }
      this.player = null
      this.acPlayerToolInit = null
    },
    // 页面关闭，关闭包括了刷新，自动调用埋点数据
    unloadHandler(e) {
      if (this.player && this.enableTrace) this.handleVideoTraceSync(this.curVideoPlayer)
    },
    backward15Seconds() {
      if (this.player) {
        const currentTime = this.player.currentTime()
        const targetTime = Math.max(0, currentTime - 15)
        this.player.currentTime(targetTime)
      }
    },
    forward15Seconds() {
      if (this.player) {
        const currentTime = this.player.currentTime()
        const duration = this.player.duration()
        if (currentTime + 15 >= duration) return
        const targetTime = Math.min(duration, currentTime + 15)
        this.player.currentTime(targetTime)
      }
    },
    handleChange(value) {
      // 竖向进度条拖动
      if (!this.player || !this.curVideoDuration) return
      const setCurTime = (this.curVideoDuration / 100) * value
      this.player.currentTime(setCurTime)
    },

    // 初始化视频
    handleInitPlayer() {
      if (this.player) return
      let initPlayCon = this.curVideoPlayer
      let idOptions = {
        app_Play_Id: new Date().getTime() + '' + Math.round(Math.random() * 999) + 1, // 播放ID（类型：String，长度16位，唯一）
        app_Id: 'IEP', // 应用ID（类型：String，也可叫做渠道ID如：wechat）
        user_Id: Math.round(Math.random() * 999) + 1, // this.userInfo.id, // 用户ID（类型：Number，调用方系统里的用户ID）
        video_Id: initPlayCon.fileId// 视频ID（类型：Number，调用方系统里的视频ID）
      }
      let userInfo = this.userInfo
      let videoTitle = this.curVideoPlayer.title
      let videoSize = 0
      let tencentid = initPlayCon.fileId
      let heartbeatsFreq = 1
      let acPlayerToolInit = window.acPlayerToolInit(`player${this.curVideoPlayer.id}`, {
        fileID: initPlayCon.fileId,
        appID: initPlayCon.appId, // 腾讯的appID
        psign: initPlayCon.psign,
        licenseUrl: 'https://1307224350.trtcube-license.cn/license/v2/1307224350_1/v_cube.license',
        fakeFullscreen: true
      }, idOptions, userInfo, videoTitle, videoSize, tencentid, heartbeatsFreq)
      this.acPlayerToolInit = acPlayerToolInit
      let player = acPlayerToolInit.player

      // let player = TCPlayer(`player${this.curVideoPlayer.id}`, { // player-container-id 为播放器容器 ID，必须与 html 中一致
      //   fileID: initPlayCon.fileId, // 请传入需要播放的视频 fileID（必须）
      //   appID: initPlayCon.appId, // 请传入点播账号的 appID（必须）
      //   // 私有加密播放需填写 psign， psign 即播放器签名，签名介绍和生成方式参见链接：https://cloud.tencent.com/document/product/266/42436
      //   psign: initPlayCon.psign,
      //   fakeFullscreen: true
      //   // licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1255472182_1/v_cube.license',
      //   // licenseUrl: 'https://license-url',
      // })
      this.poster = this.curVideoPlayer.poster ? this.curVideoPlayer.poster : this.curVideoPlayer.coverUrl || this.curVideoPlayer.url
      player.poster(this.poster)
      // 默认当前播放的player内容coverUrl
      this.player = player
      // 获取视频dom
      let videoDom = document.getElementById(`player${this.curVideoPlayer.id}`)
      this.videoDom = videoDom
      // 初始化播放按钮的dom
      if (videoDom) {
        let vjsBigPlayButtonDom = videoDom.getElementsByClassName('vjs-big-play-button')[0]
        if (vjsBigPlayButtonDom) vjsBigPlayButtonDom.style.display = 'none'
      }
      if (videoDom && !this.onWebkitBeginFullscreen) {
        this.onWebkitBeginFullscreen = () => {
          this.isRotateFullScreen = true
          this.$emit('fullscreen-change', true)
        }
        this.onWebkitEndFullscreen = () => {
          this.isRotateFullScreen = false
          this.$emit('fullscreen-change', false)
        }
        videoDom.addEventListener('webkitbeginfullscreen', this.onWebkitBeginFullscreen)
        videoDom.addEventListener('webkitendfullscreen', this.onWebkitEndFullscreen)
      }

      console.log(this.player, 'asdf')

      player.on('loadstart', () => {
        // 记录一个空格，在空格李米娜假如快进快退
        let vjsPBTDIV = document.getElementsByClassName('vjs-custom-control-spacer')[0]
        if (vjsPBTDIV && vjsPBTDIV.className.indexOf('vjs-custom-control-fast') < 0) {
          vjsPBTDIV.classList.add('vjs-custom-control-fast')
          // 将 SVG 字符串转换为 DOM 节点
          let iconBackElement = document.createElement('div')
          iconBackElement.innerHTML = iconBack
          let iconForwardElement = document.createElement('div')
          iconForwardElement.innerHTML = iconForward
          // 获取第一个子元素，即 SVG 元素
          iconForwardElement = iconForwardElement.firstChild
          iconBackElement = iconBackElement.firstChild
          iconBackElement.addEventListener('click', (e) => {
            this.backward15Seconds()
            e.stopPropagation()
          })
          iconForwardElement.addEventListener('click', (e) => {
            this.forward15Seconds()
            e.stopPropagation()
          })
          // 插入到第一个位置
          vjsPBTDIV.insertBefore(iconForwardElement, vjsPBTDIV.firstChild)
          vjsPBTDIV.insertBefore(iconBackElement, vjsPBTDIV.firstChild)
        }
        // 设置当前视频从第几秒开始,作用于播放记录
        const videoHistory = window.localStorage.getItem('videoHistory')
        let lastPlayTime = videoHistory ? JSON.parse(videoHistory)[this.curVideoPlayer.id] : 0
        player.currentTime(lastPlayTime)
        // 设置当前视频播放速度
        if (localStorage.getItem('playbackRate')) {
          player.playbackRate(localStorage.getItem('playbackRate'))
        } else {
          player.playbackRate(1)
        }
      })

      player.on('play', () => {
        if (this.enableTrace) {
          let videoSectionId = sessionStorage.getItem('videoSectionId')
          if (sessionStorage.getItem('curPlaySessionVideo')) {
            let curPlaySessionVideo = JSON.parse(sessionStorage.getItem('curPlaySessionVideo'))
            if (curPlaySessionVideo.id === videoSectionId || curPlaySessionVideo.sectionId === videoSectionId) {
              curPlaySessionVideo.duration = Math.round(this.playDurationTrace) // 页面停留时长，向上取整
              this.playDurationTrace = 0
              this.handleStaticDuration()
              handleTraceVideo(curPlaySessionVideo)
            }
          }
          sessionStorage.setItem('curPlaySessionVideo', JSON.stringify(this.curVideoPlayer))
          if ((this.curVideoPlayer.id !== videoSectionId && this.curVideoPlayer.sectionId !== videoSectionId) || !videoSectionId) {
            this.curVideoPlayer.duration = 1 // 页面停留时长，向上取整
            handleTraceVideo(this.curVideoPlayer)
          }
        }
        // 默认开始播放的时候提交状态为2
        this.$emit('handlePlay', this.curVideoPlayer)
      })

      // 播放器暂停时触发
      player.on('pause', () => {
        this.handleStashVideoTime(this.curVideoPlayer)
      })

      // 监听视频倍速切换时记录下倍速
      player.on('ratechange', (e) => {
      })

      // 当前时间变化调用的一次性函数
      player.on('timeupdate', (e) => {
        // 获取当前时间
        let curTime = player.currentTime()
        // 获取当前时间，记录当前播放时间
        this.currentTime = curTime
        // 记录当前视频总长度
        this.curVideoDuration = player.duration()
        const verticalProDom = document.getElementsByClassName('vertical-progress')[0]
        const videoBtmConDom = document.querySelector('.video-js')
        const videoBtmCon = videoBtmConDom ? videoBtmConDom.className + '' : ''
        if (verticalProDom && videoBtmConDom) {
          // 判读是否是手机
          const isMobile = /iPhone|Android/i.test(navigator.userAgent)
          const deviceWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
          if ((isMobile && deviceWidth < 768) && player.isFullscreen() && (videoBtmCon.indexOf('vjs-paused') > -1 || videoBtmCon.indexOf('vjs-user-active') > -1)) {
            verticalProDom.style.display = 'block'
          } else {
            verticalProDom.style.display = 'none'
          }
        }
        if (this.curVideoDuration) {
          this.slider = this.currentTime / this.curVideoDuration * 100
        }
        // 判断最后4秒提示跳到下一个视频，如果还有下一个视频
        // if (this.curVideoDuration - curTime <= 10) {
        //   let curIndex = 0
        //   this.videoList.map((item, index) => {
        //     if (item.id === this.curVideoPlayer.id) {
        //       curIndex = index
        //     }
        //   })
        //   if (curIndex + 1 < this.videoList.length) {
        //     let curVideo = this.videoList[curIndex + 1]
        //     this.nextVideoTitle = curVideo.title
        //     this.boolNextTip = true
        //   }
        // } else {
        //   this.boolNextTip = false
        // }
        if (this.enableTrace && curTime >= player.duration()) {
          this.handleVideoTrace(this.curVideoPlayer)
        }
        this.playDurationArr.push(curTime)
        if (this.playDurationArr.length > 1) {
          this.handleStaticDuration()
          this.$emit('timeupdate', {
            currentTime: curTime,
            playDuration: this.playDuration,
            currentVideo: this.curVideoPlayer
          })
        }
        if (this.playDurationTrace > 5) {
          this.curVideoPlayer.duration = Math.round(this.playDurationTrace) // 页面停留时长，向上取整
          this.playDurationTrace = 0
          this.handleStaticDuration()
          if (this.enableTrace) handleTraceVideo(this.curVideoPlayer)
        }
      })

      // 切换视频的全屏
      player.on('fullscreenchange', (e) => {
        // 是否显示横屏进度条
        let verticalProDom = document.getElementsByClassName('vertical-progress')[0]
        let playerDom = document.getElementById(`player${this.playerVideo.id}`)
        let playerContainerDom = player && player.el ? player.el() : null
        const vjsPlaybackRate = document.getElementsByClassName('vjs-playback-rate')[0]
        const vjsKnowledgePoints = document.getElementsByClassName('vjs-knowledge-points')[0]
        // 判读是否是手机
        const isMobile = /iPhone|Android/i.test(navigator.userAgent)
        // const isMobile = /Mobile/i.test(navigator.userAgent) // ipad Mini 监听不到
        const deviceWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        console.log(isMobile, deviceWidth < 768, navigator.userAgent, deviceWidth)
        const isFullScreen = player.isFullscreen()
        this.$emit('fullscreen-change', isFullScreen)
        if (isMobile && deviceWidth < 768) {
          this.isRotateFullScreen = isFullScreen
          let progressControlDom = document.getElementsByClassName('vjs-progress-control')[0]
          if (isFullScreen) {
            if (playerDom) playerDom.classList.add('player-isfullscreen')
            if (playerContainerDom) playerContainerDom.classList.add('player-isfullscreen')
            if (vjsPlaybackRate && vjsKnowledgePoints && this.playerVideo.knowledgeList && this.playerVideo.knowledgeList.length) {
              vjsPlaybackRate.before(vjsKnowledgePoints)
              vjsKnowledgePoints.style.display = 'flex'
            }
            if (progressControlDom) progressControlDom.style.display = 'none'
            if (verticalProDom) verticalProDom.style.display = 'block'
            stopScroll()
          } else {
            if (vjsKnowledgePoints) vjsKnowledgePoints.style.display = 'none'
            if (progressControlDom) progressControlDom.style.display = 'flex'
            if (playerDom) playerDom.classList.remove('player-isfullscreen')
            if (playerContainerDom) playerContainerDom.classList.remove('player-isfullscreen')
            if (verticalProDom) verticalProDom.style.display = 'none'
            canScroll()
          }
        } else {
          if (isFullScreen) {
            if (playerDom) playerDom.classList.add('player-isfullscreen2')
            if (playerContainerDom) playerContainerDom.classList.add('player-isfullscreen2')
            if (verticalProDom) verticalProDom.style.display = 'none'
            stopScroll()
          } else {
            if (playerDom) playerDom.classList.remove('player-isfullscreen2')
            if (playerContainerDom) playerContainerDom.classList.remove('player-isfullscreen2')
            canScroll()
          }
        }
      })
    },
    playTheVideo () {
      this.isPlayVideo = true
      // 确保播放器存在再调用播放
      if (!this.player) {
        this.handleInitPlayer()
      }
      if (this.player && this.player.play) {
        this.player.play()
      }
    },
    // 对外暴露的暂停方法，切换 Tab 时可调用
    pausePlayback() {
      if (this.player && this.player.pause) {
        this.player.pause()
        this.handleStashVideoTime(this.curVideoPlayer)
      }
    },
    // 缓存历史记录
    handleStashVideoTime(videoData) {
      if (!videoData) return
      if (window && window.localStorage && this.currentTime > 0) {
        let videoHistory = window.localStorage.getItem('videoHistory')
        if (this.curVideoDuration <= this.currentTime) {
          this.currentTime = 0
        }
        if (videoHistory) {
          videoHistory = Object.assign(JSON.parse(videoHistory), {[videoData.id]: this.currentTime})
        } else {
          videoHistory = {[videoData.id]: this.currentTime}
        }
        window.localStorage.setItem('videoHistory', JSON.stringify(videoHistory))
      }
    },
    // 视频播放时长统计
    handleStaticDuration() {
      if (this.playDurationArr.length > 1) {
        this.playDurationArr[0] = (this.playDurationArr[1] - this.playDurationArr[0] > 1 || this.playDurationArr[0] > this.playDurationArr[1]) ? this.playDurationArr[1] : this.playDurationArr[0]
        this.playDuration = this.playDuration + Number(this.playDurationArr[this.playDurationArr.length - 1]) - Number(this.playDurationArr[0])
        this.playDurationTrace = this.playDurationTrace + Number(this.playDurationArr[this.playDurationArr.length - 1]) - Number(this.playDurationArr[0])
        this.playDurationArr = [this.playDurationArr[this.playDurationArr.length - 1]]
      }
    },
    // 埋点方法（简化版，主要用于记录进度，避免空函数报错）
    handleVideoTrace(curplayer) {
      if (curplayer) {
        this.precurVideoPlayer = curplayer
      }
      this.handleStashVideoTime(this.precurVideoPlayer)
      this.handleStaticDuration()
      if (this.enableTrace && this.playDuration >= 1 && this.precurVideoPlayer) {
        this.precurVideoPlayer.duration = Math.round(this.playDurationTrace) // 页面停留时长，向上取整
        handleTraceVideo(this.precurVideoPlayer)
        this.playDuration = 0
      }
      this.currentTime = 0
    },
    // 页面关闭或者刷新的时候调用
    handleVideoTraceSync(curplayer) {
      if (curplayer) {
        this.precurVideoPlayer = curplayer
      }
      this.handleStashVideoTime(this.precurVideoPlayer)
      this.handleStaticDuration()
      if (this.enableTrace && this.playDuration > 0 && this.precurVideoPlayer) {
        this.precurVideoPlayer.duration = Math.round(this.playDurationTrace) // 页面停留时长，向上取整
        this.precurVideoPlayer = Object.assign(this.precurVideoPlayer, {
          token: Vue.ls.get(ACCESS_TOKEN),
          baseURL: process.env.baseURL
        })
        handleTraceVideoAsync(this.precurVideoPlayer)
      }
      this.currentTime = 0
    }
  }
}

</script>

<style lang="less" scoped>
.video-js {
  /deep/ .vjs-control-bar {
    .vjs-play-control, .vjs-volume-panel, .vjs-mute-control, .vjs-volume-control, .vjs-current-time, .vjs-duration, .vjs-playback-rate, .vjs-fullscreen-control {
      width: 3em;
    }
  }

  /deep/ .vjs-pdt-time {
    display: none;
  }

  /deep/ .vjs-custom-control-spacer {
    flex: 1;
  }

  /deep/ .vjs-control-bar {
    display: flex;
    align-items: center;
  }

  /deep/ .vjs-volume-panel.vjs-volume-panel-vertical {
    width: 3em;
  }

  /deep/ .vjs-barrage-switcher {
    display: none;
  }

  /deep/ .vjs-mute-control {
    padding: 0;
  }

  /deep/ .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical {
    left: -3em;
    margin-left: 0;
  }

  /deep/ .tcp-video-quality-switcher {
    display: none;
  }

  /deep/ .vjs-custom-control-fast {
    display: flex !important;
    align-items: center;
    width: 80px !important;
  }
  /deep/ .icon_fast {
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    margin-right: 10px;
  }
}
</style>
<style lang="less" scoped>
.player {
  width: 100%;
  position: relative;

  &.isFullPlayer {
    position: fixed !important;
    z-index: 10000 !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    overflow: visible !important;
    background: #000;
  }

  .video-block {
    width: 100%;
    height: 200px;
    position: absolute;
    top: 0;
    left: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #000;

    .video-cover {
      display: block;
      width: 100%;
      height: 200px;
      position: relative;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
    .icon-video {
      position: absolute;
      width: 40px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .knowledge-points-list {
    position: fixed;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    background: rgba(0, 0, 0, .8);
    border-radius: 20px;
    padding: 0 15px 10px;
    width: 205px;
    height: calc(100vw - 60px);
    left: 98vw;
    top: calc(100vh - 240px);
    box-sizing: border-box;
    -webkit-transform-origin: top left !important;
    -ms-transform-origin: top left !important;
    transform-origin: top left !important;
    -webkit-transform: rotate(90deg) !important;
    -ms-transform: rotate(90deg) !important;
    transform: rotate(90deg) !important;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;

      .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #fff;
      }

      .header-right {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #fff;

        i {
          font-style: normal;
          color: #EB1700;
        }
      }
    }

    .cont {
      flex: 1;
      height: 0;
      padding: 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .dot-list-fullscreen {
        flex: 1;
        height: 0;
        overflow-y: auto;
        padding-right: 16px;
        margin-right: -16px;
        position: relative;

        .dot-item-fullscreen {
          cursor: pointer;
          position: relative;
          margin-bottom: 10px;

          .dot-item-cont {
            display: flex;
            align-items: flex-start;

            .dot-icon {
              margin-right: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 6px;

              img {
                width: 6px;
              }
            }

            .dot-title {
              display: flex;
              flex: 1;
              align-items: flex-start;

              .time {
                font-family: PingFang HK, PingFang HK;
                font-weight: 400;
                font-size: 12px;
                color: #FFF;
              }

              .name {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #FFF;
                flex: 1;
              }
            }
          }

          &:last-child {
            height: auto;
            margin-bottom: 0;

            .dot-line {
              display: none;
            }
          }

          .dot-line {
            position: absolute;
            top: 14px;
            left: 2px;
            width: 2px;
            height: 100%;
            border-radius: 10px;
            background: url("~@/assets/images/course/dot-line.png") no-repeat center center / 100% 100%;
          }

          &.cur {
            .dot-item-cont {
              .dot-title {
                .time {
                  color: #EB1700;
                }

                .name {
                  color: #EB1700;
                }
              }
            }
          }
        }
      }

      .course-summary {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #5F5F5F;

        span {
          font-weight: 500;
          color: #2B2B2B;
        }
      }
    }
  }

  .video-player {
    width: 100%;
    left: 0;
    height: 200px;

    &.player-isfullscreen2 {
      z-index: 999 !important;
    }

    &.player-isfullscreen {
      position: fixed !important;
      z-index: 9999 !important;
      top: 0 !important;
      left: 100% !important;
      bottom: 0 !important;
      right: 0 !important;
      height: 100vw !important;
      width: 100vh !important;
      -webkit-transform-origin: top left !important;
      -ms-transform-origin: top left !important;
      transform-origin: top left !important;
      -webkit-transform: rotate(90deg) !important;
      -ms-transform: rotate(90deg) !important;
      transform: rotate(90deg) !important;
    }
  }

  /deep/ .video-js.player-isfullscreen2 {
    z-index: 9999 !important;
  }

  /deep/ .video-js.player-isfullscreen {
    position: fixed !important;
    z-index: 10000 !important;
    top: 0 !important;
    left: 100% !important;
    bottom: 0 !important;
    right: 0 !important;
    height: 100vw !important;
    width: 100vh !important;
    -webkit-transform-origin: top left !important;
    -ms-transform-origin: top left !important;
    transform-origin: top left !important;
    -webkit-transform: rotate(90deg) !important;
    -ms-transform: rotate(90deg) !important;
    transform: rotate(90deg) !important;
  }

  .vjs-knowledge-points {
    display: none;
    color: #fff;
    font-weight: bold;
    align-items: center;

    &.isFull {
      display: flex;
    }
  }

  .vertical-progress {
    position: fixed;
    left: 42px;
    height: calc(100vh - 20px);
    margin: 10px 0;
    z-index: 9999;
    top: 0;
    display: none;

    &.isFull {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/compontents/TrainingCampVideoPlayer.vue